import styles from './styles.module.scss';
import { BreakpointMobileUp } from '../../constants/ui';
import { useViewport } from '../../hooks';

// min, max for mobile only
const MetricCard = ({ t, id, icon, label, labelMobile, value, valueSecondary = null, isActive, clickCard }) => {
  const { widthViewport } = useViewport();

  const onClickMetricCard = () => {
    clickCard();
  };

  return (
    <div className={`${styles.metricCard} ${isActive ? styles.metricCardActive : ''}`}>
      <button className={styles.metricCardButton} onClick={onClickMetricCard}></button>
      <div className={styles.metricCardHeader}>
        {icon && <img className={styles.metricCardIcon} src={icon} alt={label} width="24" height="24" />}
        {label && (
          <span className={styles.metricCardLabel}>
            {labelMobile && widthViewport < BreakpointMobileUp ? labelMobile : label}
          </span>
        )}
      </div>

      {!(widthViewport < BreakpointMobileUp && id === 'humidity') && (
        <div className={`${styles.metricCardValue}`}>
          {(!value || value === t('empty.noData')) && value !== 0 && valueSecondary === null ? (
            <span className={`${styles.metricCardValueMuted} text-muted`}>{t('empty.noData')}</span>
          ) : (
            (value !== null && value) && <span>{value}</span>
          )}
          {valueSecondary !== null && (
            <span>{valueSecondary}</span>
          )}
        </div>
      )}

      {id === 'humidity' &&
        widthViewport < BreakpointMobileUp &&
        (value || value === 0 ? (
          // Mobile (Circle Diagram)
          <div className={`${styles.metricCardCircle}`}>
            <svg viewBox="0 0 34 34" width="44" height="44" xmlns="http://www.w3.org/2000/svg">
              <circle
                className="circle-chart__background"
                stroke="var(--neutral-3)"
                strokeWidth="4"
                fill="none"
                cx="16.86"
                cy="16.86"
                r="15"
              />
              <circle
                className="circle-chart__circle"
                stroke="var(--blue-7)"
                strokeWidth="4"
                strokeDasharray={`${value ? value.slice(0, -1) : 0},100`}
                strokeLinecap="round"
                fill="none"
                cx="16.86"
                cy="16.86"
                r="15"
              />
            </svg>
            {value.slice(0, -1)}
          </div>
        ) : (
          <div className={styles.metricCardValue}>
            <span className={`${styles.metricCardValueMuted} text-muted`}>{t('empty.noData')}</span>
          </div>
        ))}
    </div>
  );
};

export default MetricCard;
